import React from 'react';
import '../../App.css';
import '../cost-fund/costWrapp.css';

function CostWrapp({ data }) {
  return (
    <section className="cost-wrapp">
        <div className="container">
              {data.Costs1 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.Costs1 }}
          ></div>
        )}

            <div className="row cost-row">
                <div className="col-md-6">
                    <div className="cost-row1">
                         {data.Costs2 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.Costs2 }}
          ></div>
        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="cost-row2">
                        {data.Costs3 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.Costs3 }}
          ></div>
        )}
                    </div>
                </div>
            </div>
            <div className="cost-row3">
                <h3><strong>{data.Costs4}</strong></h3>
                <div className="cost-calc">
                    <div className="calc-card gross">
                        <h5>{data.Costs5}</h5>
                        <span className="value">{data.Costs6}</span>
                    </div>
                    <div className="calc-card apprv">
                        <h5>{data.Costs7}</h5>
                        <span className="value">{data.Costs8}</span>
                    </div>
                    <div className="calc-card net">
                        <h5>{data.Costs9}</h5>
                        <span className="value">{data.Costs10}</span>
                    </div>
                </div>
                <div className="cost-disc">
                   {data.Costs11 && (
          <div
            dangerouslySetInnerHTML={{ __html: data.Costs11 }}
          ></div>
        )}
                </div>
            </div>
        </div>
    </section>
  )
}

export default CostWrapp
